import styled from "styled-components";
import { Loader } from "../Common";

export const ButtonComp = ({
  btnText,
  divClassName,
  btnClassName,
  onClick,
  type,
  BorderColor,
  BorderWidth,
  ButtonInlineStyle,
  loading,
  ...props
}) => {
  return (
    <ButtonStyle
      className="w-full"
      BorderColor={BorderColor}
      BorderWidth={BorderColor ? "2px" : BorderWidth}
    >
      <div className={`${divClassName}`}>
        <button
          className={`${btnClassName} flex items-center justify-center`}
          style={{ ...ButtonInlineStyle }}
          onClick={onClick}
          disabled={loading}
          {...props}
          type={type}
        >
          {loading ? (
            <>
              <Loader
                size="sm"
                color="white"
                variant="spinner"
                className="mr-2"
              />
              Loading...
            </>
          ) : (
            btnText
          )}
        </button>
      </div>
    </ButtonStyle>
  );
};
const ButtonStyle = styled.div`
  button {
    background: transparent;
    border-color: ${(props) => props.BorderColor} !important;
    border-width: ${(props) => props.BorderWidth} !important;
  }
`;
